export const MAIN_CONTAINER_CLASS = 'main__container'
